__webpack_require__.p = "/techjanet/";